webpackJsonp(["cu-product-compare.module"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js"),
    now = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/now.js"),
    toNumber = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toNumber.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

module.exports = now;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toNumber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js"),
    isSymbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/uniqueId.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toString.js");

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/cu-product-compare.module.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;
exports.exec = exec;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

var _exec = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/exec.js");

var _exec2 = _interopRequireDefault(_exec);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Health Fund Product Selector Module Bundle
 * @author Rhys Lloyd
 */
// Dependencies
var MODULE_NAME = _names.CU_PRODUCT_COMPARE_MODULE;

//
// Constants

var log = (0, _debug2.default)(MODULE_NAME);
//
// Register
if (!registry.exists(MODULE_NAME)) {
	registry.register(MODULE_NAME, registry.STATE.LOADING);
}

//
// Functions
function exec() {
	(0, _exec2.default)();
}

exports.default = exec;

registry.setState(MODULE_NAME, registry.STATE.LOADED);

//
// Conditionally Self Execute
if (!registry.isRegistered(MODULE_NAME)) {
	exec();
	registry.setState(MODULE_NAME, registry.STATE.REGISTERED);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/dynamic-load.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSETS = exports.MODULE_SELECTOR = exports.MODULE_NAME = undefined;
exports.default = load;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// Constants
/**
 * Credit Union Product Compare - Dynamic Load
 * Responsible for determining if the PC table is present, and for actually loading the files.
 * @author Oliver Boermans
 */

//
// Dependencies
var MODULE_NAME = exports.MODULE_NAME = _names.CU_PRODUCT_COMPARE_MODULE;
var MODULE_SELECTOR = exports.MODULE_SELECTOR = '[data-cu-pc]';
var ASSETS = exports.ASSETS = ['../styles/cu-product-compare.module.css', '../scripts/cu-product-compare.module.js'];

//
// Load
function load() {
  registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/exec.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _dynamicLoad = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/dynamic-load.js");

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'cu-product-compare/exec'; /**
                                              * Product Compare
                                              * @author Oliver Boermans
                                              */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

// Dependencies


/**
 * Run module
 */
function exec() {
	log('Running...');

	// Find all elements and operate
	var elements = document.querySelectorAll(_dynamicLoad.MODULE_SELECTOR);
	log('elements:', elements);

	// Backward loops are just faster
	for (var i = elements.length - 1; i >= 0; --i) {
		(0, _index2.default)(elements[i]);
	}
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = init;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _uniqueId = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/uniqueId.js");

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _sineInOut = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/eases/sine-in-out.js");

var _sineInOut2 = _interopRequireDefault(_sineInOut);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _scrollmonitor = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/scrollmonitor/scrollMonitor.js");

var _scrollmonitor2 = _interopRequireDefault(_scrollmonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'cu-product-compare'; /**
                                         * Credit Union Product Compare
                                         * @author Oliver Boermans
                                         */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

//
// Dependencies


//
// Constants
var pc = {
	isCollapsed: false,
	hasFiltered: false,
	hasHidden: false
};

var TABLE_SELECTOR = 'table[data-cu-pc-table]';
var TABLE_COLLAPSED_CLASS = 'is-collapsed';

var SCROLL_PANE_SELECTOR = 'div[data-cu-pc-pane]';
var SCROLL_BUTTON_LEFT_SELECTOR = 'button[data-cu-pc-scroll-left]';
var SCROLL_BUTTON_RIGHT_SELECTOR = 'button[data-cu-pc-scroll-right]';
var SCROLL_EDGE_THRESHOLD = 5;
var SCROLL_DURATION = 500;

var STICKY_ELEMENT_SELECTOR = 'div[data-cu-pc-sticky]';
var STICKY_WATCH_SELECTOR = 'div[data-cu-pc-sticky-watch]';
var STICKY_WATCH_OFFSETS = { top: 0, bottom: -350 };
var STICKY_CLASS = 'is-stuck';

var TOGGLE_MORE_BUTTON_SELECTOR = 'button[data-cu-pc-toggle-more]';
var TOGGLE_MORE_BUTTON_LABEL_SELECTOR = 'span[data-cu-pc-toggle-more-label]';
var TOGGLE_MORE_BUTTON_COLLAPSED_CLASS = 'is-collapsed';
var TOGGLE_MORE_BUTTON_OPEN_LABEL = 'Show less';
var TOGGLE_MORE_BUTTON_COLLAPSED_LABEL = 'Show more';

var RESET_BUTTON_SELECTOR = 'button[data-pc-product-reset]';

var HIDE_PRODUCT_BUTTON_SELECTOR = 'button[data-pc-hide-product]';
var HIDE_PRODUCT_CLASS_PREFIX = 'has-hidden-product-';

var PRODUCT_HEAD_CELL_SELECTOR = 'th[data-cu-pc-head-cell]';
var PRODUCT_HEAD_LINK_SELECTOR = 'a[data-cu-pc-head-cell-link]';

var FILTER_CATEGORY_CLASS_PREFIX = 'has-filter-product-category-';
var CATEGORY_FILTER_INPUT_SELECTOR = 'input[data-pc-category-filter]';

var COLUMN_RULER_CLASS = 'cu-pc-column-ruler';

var enableButton = function enableButton(button, enable) {
	button.attr('disabled', enable ? null : 'disabled');
};

var focusNextProduct = function focusNextProduct(fromCell) {
	var toFocus = fromCell.nextAll().filter(':visible').first();

	//	Focus first following visible product
	if (toFocus.length) {
		toFocus.find(PRODUCT_HEAD_LINK_SELECTOR).focus();
	} else {
		//	Look for previous instead
		toFocus = fromCell.prevAll(PRODUCT_HEAD_CELL_SELECTOR).filter(':visible').first();

		//	if visible focus it
		if (toFocus.length) {
			toFocus.find(PRODUCT_HEAD_LINK_SELECTOR).focus();
		} else {
			//	There are no remaining visible products
			//	Focus reset button
			this.resetButton.focus();
		}
	}
};

var hideProduct = function hideProduct(id, button) {
	var headCell = button.closest(PRODUCT_HEAD_CELL_SELECTOR);
	this.compareTable.addClass('' + HIDE_PRODUCT_CLASS_PREFIX + id);

	//	Enable reset button
	enableButton(this.resetButton, true);
	focusNextProduct.call(this, headCell);
	this.hasHidden = true;
	updateScrollButtonState.apply(this);
};

var updateScrollButtonState = function updateScrollButtonState() {
	var pane = this.scrollPane[0];

	var scrollLeft = pane.scrollLeft;
	var scrollLeftMax = pane.scrollWidth - pane.clientWidth;

	var canScrollLeft = scrollLeft > SCROLL_EDGE_THRESHOLD;
	var canScrollRight = scrollLeftMax - scrollLeft > SCROLL_EDGE_THRESHOLD;

	enableButton(this.scrollButtonLeft, canScrollLeft);
	enableButton(this.scrollButtonRight, canScrollRight);
};

var smoothScrollPane = function smoothScrollPane(param, timestamp) {
	//	param = {startPos, direction, duration [, startTime]}

	var startTime = param.startTime !== undefined ? param.startTime : timestamp;
	var startPos = param.startPos;
	var direction = param.direction;
	var duration = param.duration;
	var pane = this.scrollPane[0];
	var scrollStep = this.columnRuler.width();

	var timeElapsed = timestamp - startTime;
	var easeElapsed = timeElapsed / duration;
	var targetScrollDist = scrollStep * direction;

	pane.scrollLeft = startPos + targetScrollDist * (0, _sineInOut2.default)(easeElapsed);

	if (timeElapsed < duration) {
		window.requestAnimationFrame(smoothScrollPane.bind(this, {
			startPos: startPos,
			direction: direction,
			duration: duration,
			startTime: startTime
		}));
	}
};

var doScrollLeft = function doScrollLeft() {
	var pane = this.scrollPane[0];

	//	TODO test for requestAnimationFrame support
	//	If none jump straight to target
	window.requestAnimationFrame(smoothScrollPane.bind(this, {
		startPos: pane.scrollLeft,
		direction: -1,
		duration: SCROLL_DURATION
	}));
};

var doScrollRight = function doScrollRight() {
	var pane = this.scrollPane[0];

	window.requestAnimationFrame(smoothScrollPane.bind(this, {
		startPos: pane.scrollLeft,
		direction: 1,
		duration: SCROLL_DURATION
	}));
};

var removeClassesPrefixed = function removeClassesPrefixed($element, prefix) {
	var classPrefixLength = prefix.length;
	var classesToRemove = $element.attr('class').split(' ').filter(function (aClass) {
		return aClass.slice(0, classPrefixLength) === prefix;
	});
	$element.removeClass(classesToRemove.join(' '));
};

var unHideProducts = function unHideProducts() {

	//	Re-display individually hidden products
	removeClassesPrefixed(this.compareTable, HIDE_PRODUCT_CLASS_PREFIX);

	//	Reset category filter
	removeClassesPrefixed(this.compareTable, FILTER_CATEGORY_CLASS_PREFIX);
	if (this.categoryFilterInputs) {

		this.categoryFilterInputs.val(['0']);
	}

	//	Reset reset
	enableButton(this.resetButton, false);
	this.hasFiltered = false;
	this.hasHidden = false;

	updateScrollButtonState.apply(this);
};

var showLess = function showLess() {
	this.compareTable.addClass(TABLE_COLLAPSED_CLASS);
	this.toggleMoreButtons.addClass(TOGGLE_MORE_BUTTON_COLLAPSED_CLASS).find(TOGGLE_MORE_BUTTON_LABEL_SELECTOR).text(TOGGLE_MORE_BUTTON_COLLAPSED_LABEL);
	this.isCollapsed = true;
};

var showMore = function showMore() {
	this.compareTable.removeClass(TABLE_COLLAPSED_CLASS);
	this.toggleMoreButtons.removeClass(TOGGLE_MORE_BUTTON_COLLAPSED_CLASS).find(TOGGLE_MORE_BUTTON_LABEL_SELECTOR).text(TOGGLE_MORE_BUTTON_OPEN_LABEL);
	this.isCollapsed = false;
};

var toggleMore = function handleToggleButtonClick() {
	var toggle = this.isCollapsed ? showMore : showLess;
	toggle.apply(this);

	//	Height of the table has changed
	//	Let the sticky buttons know
	_scrollmonitor2.default.update();
};

var applyFilter = function applyFilter(category) {

	//	Remove existing category filter classes
	removeClassesPrefixed(this.compareTable, FILTER_CATEGORY_CLASS_PREFIX);

	//	add new filter class
	this.compareTable.addClass('' + FILTER_CATEGORY_CLASS_PREFIX + category);

	//	update reset state
	if (category != 0) {

		enableButton(this.resetButton, true);
		this.hasFiltered = true;

		//	check that no items are hidden before resetting
	} else if (!this.hasHidden) {

		enableButton(this.resetButton, false);
		this.hasFiltered = false;
	}

	updateScrollButtonState.apply(this);
};

var onFilterChange = function onFilterChange() {
	var category = $('input[name="result_filter"]:checked').val();
	applyFilter.call(this, category);
};

//	Triggered when short table all visible in viewport
//	and when tall fills the viewport
var onStickyFit = function stickButtons(element) {
	log("stickButtons");

	//	Do not stick buttons if table is contained in viewport
	if (this.isAboveViewport && this.isBelowViewport) {
		$(element).addClass(STICKY_CLASS);
	} else {
		$(element).removeClass(STICKY_CLASS);
	}
};

var unStickButtons = function unStickButtons(element) {
	log("unStickButtons");
	$(element).removeClass(STICKY_CLASS);
};

var stickyWatchEnters = function stickyWatchEnters(element) {
	log("stickyWatchEnters");

	//	Stick buttons when scrolling up from below
	if (this.isAboveViewport) {
		$(element).addClass(STICKY_CLASS);
	}
};

var stickyWatchExitsBottom = function stickyWatchExitsBottom(element) {
	log("stickyWatchExitsBottom");

	if (this.isAboveViewport) {
		$(element).removeClass(STICKY_CLASS);
	}
};

var stickyWatchExitsTop = function stickyWatchExitsTop(element) {
	log("stickyWatchExitsTop");

	if (this.isBelowViewport) {
		$(element).removeClass(STICKY_CLASS);
	}
};

/**
 * Initialises the product selector.
 * @param {Element} element
 */
function init(element) {
	log('init', element);
	element.id = (0, _uniqueId2.default)('cu-pc');

	//	Find elements
	pc.compareTable = $(TABLE_SELECTOR, element);

	if (!pc.compareTable.length) {
		log('No comparison table, bye…');
		return false;
	}

	pc.scrollPane = $(SCROLL_PANE_SELECTOR, element);
	pc.scrollButtonLeft = $(SCROLL_BUTTON_LEFT_SELECTOR, element);
	pc.scrollButtonRight = $(SCROLL_BUTTON_RIGHT_SELECTOR, element);
	pc.toggleMoreButtons = $(TOGGLE_MORE_BUTTON_SELECTOR, element);
	pc.hideProductButtons = $(HIDE_PRODUCT_BUTTON_SELECTOR, element);
	pc.resetButton = $(RESET_BUTTON_SELECTOR, element);
	pc.categoryFilterInputs = $(CATEGORY_FILTER_INPUT_SELECTOR, element);
	pc.stickyButtons = $(STICKY_ELEMENT_SELECTOR, element);
	pc.stickyWatchSubject = $(STICKY_WATCH_SELECTOR, element);

	//	Insert column ruler
	//	Width determined by CSS
	//	Measured to determine scroll distances
	pc.columnRuler = $('<div></div>', {
		'class': COLUMN_RULER_CLASS
	}).prependTo(element);

	var watcher = _scrollmonitor2.default.create(pc.stickyWatchSubject, STICKY_WATCH_OFFSETS);

	//	Event Handlers
	pc.toggleMoreButtons.on('click', toggleMore.bind(pc));
	pc.hideProductButtons.each(function (index, button) {
		var $button = $(button);
		var productId = $button.data('pc-hide-product');

		$button.on('click', hideProduct.bind(pc, productId, $button));
	});
	pc.resetButton.on('click', unHideProducts.bind(pc));
	pc.scrollPane.on('scroll', (0, _debounce2.default)(updateScrollButtonState.bind(pc), 250));
	$(window).on('resize', (0, _debounce2.default)(updateScrollButtonState.bind(pc), 250));
	pc.scrollButtonLeft.on('click', doScrollLeft.bind(pc));
	pc.scrollButtonRight.on('click', doScrollRight.bind(pc));

	if (pc.categoryFilterInputs.length) {
		pc.categoryFilterInputs.on('change', onFilterChange.bind(pc));
	}

	//	stick buttons when table top meets top of viewport
	watcher.fullyEnterViewport(onStickyFit.bind(watcher, pc.stickyButtons));

	//	stick buttons when table bottom enters from top of viewport (with offset)
	watcher.enterViewport(stickyWatchEnters.bind(watcher, pc.stickyButtons));

	//	unstick buttons when table top falls below top of viewport
	watcher.partiallyExitViewport(stickyWatchExitsTop.bind(watcher, pc.stickyButtons));

	//	unstick buttons when table bottom exists top of viewport (with offset)
	watcher.exitViewport(stickyWatchExitsBottom.bind(watcher, pc.stickyButtons));

	//	initial state
	enableButton(pc.resetButton, false);
	showLess.apply(pc);
	onFilterChange.apply(pc);
	updateScrollButtonState.apply(pc);

	return;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/dynamic-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dynamicLoader;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var _toast = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/pyrsmk-toast/toast.js");

var _toast2 = _interopRequireDefault(_toast);

var _isString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isString.js");

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'dynamic-loader'; /**
                                     * Registry Dynamic Loader
                                     * Common dynamic loading template.
                                     * @author Rhys Lloyd
                                     */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);
//
// Dependencies


var staticPath = undefined;
var staticPathElement = document.querySelector('meta[name="site.paths.static"]');
if (staticPathElement) {
	staticPath = staticPathElement.content;
}

//
// Constants
var STATIC_PATH = staticPath;
var MANIFEST_FILE = STATIC_PATH + 'manifest.json';
var MANIFEST_FILE_DATA = undefined;
//
// Load

/**
 * Loads a module based on the existence of a selector.
 * @param {String} module - name of module to load (for registration)
 * @param {String} selector - selector to test for with document.querySelector
 * @param {Array} loadArray - array of assets to load (pass to toast.js)
 */
function dynamicLoader(module, selector, loadArray) {
	if ((0, _index.exists)(module)) {
		log('Module "' + module + '" already loaded. Exiting.');
		return;
	}

	log('Looking for selector "' + selector + '"');
	var hasElements = !!document.querySelector(selector);

	if (!hasElements) {
		log('...no elements. Exiting.');
		(0, _index.register)(module, _index.STATE.NOT_REQUIRED);
		return;
	}

	readTextFile(MANIFEST_FILE, getManifestFileName, loadArray, module);
}

function getManifestFileName(text, loadArray, module) {
	var MANIFEST_FILE_DATA = JSON.parse(text);
	var resolvedLoadArray = loadArray.map(function (item) {
		if (!(0, _isString2.default)(item)) {
			return item;
		}
		var newItem = item.replace('../', STATIC_PATH);
		if (MANIFEST_FILE_DATA[newItem]) {
			return MANIFEST_FILE_DATA[newItem];
		}
		return newItem;
	});

	log('Loading ' + module + ' with assetArray', resolvedLoadArray);
	_toast2.default.apply(null, resolvedLoadArray);

	(0, _index.register)(module, _index.STATE.LOADING);
}

function readTextFile(file, callback, loadArray, module) {
	var rawFile = new XMLHttpRequest();
	rawFile.overrideMimeType("application/json");
	rawFile.open("GET", file, true);
	rawFile.onreadystatechange = function () {
		if (rawFile.readyState === 4 && rawFile.status == "200") {
			return callback(rawFile.responseText, loadArray, module);
		}
	};
	rawFile.send(null);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exports.STATE = undefined;

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

Object.keys(_names).forEach(function (key) {
	if (key === "default" || key === "__esModule") return;
	Object.defineProperty(exports, key, {
		enumerable: true,
		get: function get() {
			return _names[key];
		}
	});
});
exports.register = register;
exports.exists = exists;
exports.isRegistered = isRegistered;
exports.getState = getState;
exports.setState = setState;
exports.validState = validState;
exports.dynamicLoader = dynamicLoader;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _state = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/state.js");

var _state2 = _interopRequireDefault(_state);

var _dynamicLoader = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/dynamic-loader.js");

var dl = _interopRequireWildcard(_dynamicLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'registry'; /**
                               * Extremely Basic Module Registry
                               * Designed to prevent asynchronously modules from being loaded and run more than once.
                               * @author Rhys Lloyd
                               */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

//
// Dependencies


//
// Constants
var REGISTRY = {};
var STATE = exports.STATE = _state2.default;

//
// Functions

/**
 * Registers a module.
 * @param module
 * @param state
 * @returns {*}
 */
function register(module, state) {
	if (exists(module)) {
		log('register(): Attempting to re-register an existing module: "' + module + '"', 'Existing:', REGISTRY[module]);
		return;
	}

	if (!state || !validState(state)) {
		state = STATE.INIT;
	}

	REGISTRY[module] = {
		state: state
	};

	log('register(): Registering module "' + module + '" with state "' + state.name + '"');
	return REGISTRY[module];
}

/**
 * Returns the object in the registry
 * @param module
 * @returns {*}
 */
function exists(module) {
	return !!REGISTRY[module];
}

/**
 * Checks if a module is marked as registered.
 * @param module
 * @returns {*|boolean}
 */
function isRegistered(module) {
	return exists(module) && getState(module) == STATE.REGISTERED;
}

/**
 * Get the state of a registered module.
 * @param module
 * @returns {*}
 */
function getState(module) {
	if (!exists(module)) {
		log('getState(): module "' + module + '" doesn\'t exist');
		return;
	}

	var state = REGISTRY[module].state;
	log('getState(): Getting state "' + state.name + '" for module "' + module + '"');
	return state;
}

/**
 * Get the state of a registered module.
 * @param module
 * @param state
 * @returns {*}
 */
function setState(module, state) {
	if (!exists(module)) {
		log('setState(): module "' + module + '" doesn\'t exist');
		return;
	}

	if (!validState(state)) {
		log('setState(): state "' + state + '" doesn\'t exist (attempt on module "' + module + '")');
	}

	log('setState(): Setting state "' + state.name + '" for module "' + module + '"');
	REGISTRY[module].state = state;
}

/**
 * Verifies that a state is valid
 * @param state
 * @returns {boolean}
 */
function validState(state) {
	return state instanceof _state2.default;
}

exports.default = register;
function dynamicLoader(module, selector, loadArray) {
	return dl.default(module, selector, loadArray);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Registry Module Names
 */

// Core
var CORE_MODULE = exports.CORE_MODULE = 'core';
var DATEPICKER_MODULE = exports.DATEPICKER_MODULE = 'datepicker';
var PS_QUOTE_FORM_MODULE = exports.PS_QUOTE_FORM_MODULE = 'ps-quote-form';
var LOCATOR_MODULE = exports.LOCATOR_MODULE = 'locator';
var COVER_SELECTOR_MODULE = exports.COVER_SELECTOR_MODULE = "cover-selector";

// Dev
var DEV_MODULE = exports.DEV_MODULE = 'dev';
var DEV_THEME_SWITCHER = exports.DEV_THEME_SWITCHER = DEV_MODULE + '-theme-switcher';

// Health Fund
var HF_APP_MODULE = exports.HF_APP_MODULE = 'hf-app';
var HF_PRODUCT_SELECTOR_MODULE = exports.HF_PRODUCT_SELECTOR_MODULE = 'hf-product-selector';
var HF_PRODUCT_DETAIL_CARD_MODULE = exports.HF_PRODUCT_DETAIL_CARD_MODULE = 'hf-product-detail-card';

// Credit Union
var CU_APP_MODULE = exports.CU_APP_MODULE = 'cu-app';
var CU_PRODUCT_COMPARE_MODULE = exports.CU_PRODUCT_COMPARE_MODULE = 'cu-product-compare';

// NT Health Fund
var NT_HF_APP_MODULE = exports.NT_HF_APP_MODULE = 'nt-cu-app';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/state.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enumify = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/enumify/enumify.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Registry States
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * States for Registry
 * See docs: https://github.com/rauschma/enumify
 */
var State = function (_Enum) {
  _inherits(State, _Enum);

  function State() {
    _classCallCheck(this, State);

    return _possibleConstructorReturn(this, (State.__proto__ || Object.getPrototypeOf(State)).apply(this, arguments));
  }

  return State;
}(_enumify.Enum);

State.initEnum(['INIT', 'FAIL', 'LOADING', 'LOADED', 'REGISTERED', 'NOT_REQUIRED', 'CANCELLED']);

exports.default = State;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/eases/sine-in-out.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function sineInOut(t) {
  return -0.5 * (Math.cos(Math.PI * t) - 1);
}

module.exports = sineInOut;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/enumify/enumify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyProperties = copyProperties;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var INITIALIZED = Symbol();

/**
 * This is an abstract class that is not intended to be
 * used directly. Extend it to turn your class into an enum
 * (initialization is performed via `MyClass.initEnum()`).
 */

var Enum = exports.Enum = function () {
    /**
     * `initEnum()` closes the class. Then calling this constructor
     * throws an exception.
     * 
     * If your subclass has a constructor then you can control
     * what properties are added to `this` via the argument you
     * pass to `super()`. No arguments are fine, too.
     */

    function Enum() {
        var instanceProperties = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

        _classCallCheck(this, Enum);

        // new.target would be better than this.constructor,
        // but isn’t supported by Babel
        if ({}.hasOwnProperty.call(this.constructor, INITIALIZED)) {
            throw new Error('Enum classes can’t be instantiated');
        }
        if ((typeof instanceProperties === 'undefined' ? 'undefined' : _typeof(instanceProperties)) === 'object' && instanceProperties !== null) {
            copyProperties(this, instanceProperties);
        }
    }
    /**
     * Set up the enum, close the class.
     * 
     * @param arg Either an object whose properties provide the names
     * and values (which must be mutable objects) of the enum constants.
     * Or an Array whose elements are used as the names of the enum constants
     * The values are create by instantiating the current class.
     */

    _createClass(Enum, [{
        key: 'toString',

        /**
         * Default `toString()` method for enum constant.
         */
        value: function toString() {
            return this.constructor.name + '.' + this.name;
        }
    }], [{
        key: 'initEnum',
        value: function initEnum(arg) {
            Object.defineProperty(this, 'enumValues', {
                value: [],
                configurable: false,
                writable: false,
                enumerable: true
            });
            if (Array.isArray(arg)) {
                this._enumValuesFromArray(arg);
            } else {
                this._enumValuesFromObject(arg);
            }
            Object.freeze(this.enumValues);
            this[INITIALIZED] = true;
            return this;
        }
    }, {
        key: '_enumValuesFromArray',
        value: function _enumValuesFromArray(arr) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    this._pushEnumValue(new this(), key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: '_enumValuesFromObject',
        value: function _enumValuesFromObject(obj) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(obj)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    var value = new this(obj[key]);
                    this._pushEnumValue(value, key);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: '_pushEnumValue',
        value: function _pushEnumValue(enumValue, name) {
            enumValue.name = name;
            enumValue.ordinal = this.enumValues.length;
            Object.defineProperty(this, name, {
                value: enumValue,
                configurable: false,
                writable: false,
                enumerable: true
            });
            this.enumValues.push(enumValue);
        }

        /**
         * Given the name of an enum constant, return its value.
         */

    }, {
        key: 'enumValueOf',
        value: function enumValueOf(name) {
            return this.enumValues.find(function (x) {
                return x.name === name;
            });
        }

        /**
         * Make enum classes iterable
         */

    }, {
        key: Symbol.iterator,
        value: function value() {
            return this.enumValues[Symbol.iterator]();
        }
    }]);

    return Enum;
}();

function copyProperties(target, source) {
    // Ideally, we’d use Reflect.ownKeys() here,
    // but I don’t want to depend on a polyfill
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = Object.getOwnPropertyNames(source)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            var desc = Object.getOwnPropertyDescriptor(source, key);
            Object.defineProperty(target, key, desc);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return target;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/pyrsmk-toast/toast.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
	} else {
		root.toast = factory();
	}
})(undefined, function () {
	/*! toast 2.1.0 (https://github.com/pyrsmk/toast) */

	var handled_resources = {};

	function toast() {
		var head = document.getElementsByTagName('head')[0],


		// Load as much resources as we can
		loadResources = function loadResources(resources) {
			// Waiting for DOM readiness then load resources
			if (!head) {
				setTimeout(function () {
					loadResources(resources);
				}, 50);
			}
			// Load resources
			else if (resources.length) {
					var i = -1,
					    resource,
					    callback;
					while (resource = resources[++i]) {
						// Resource
						if (typeof resource == 'string') {
							loadResource(resource);
						}
						// Callback
						else if (typeof resource == 'function') {
								callback = resource;
								break;
							}
					}
					watchResources(callback, Array.prototype.slice.call(resources, i + 1));
				}
		},


		// Load one resource
		loadResource = function loadResource(resource) {
			// Extract resource type
			var implicit_type = /\.(\w+)$/.exec(resource),
			    explicit_type = /^\[(\w+)\](.+)/.exec(resource),
			    type,
			    node;
			if (explicit_type !== null) {
				type = explicit_type[1];
				resource = explicit_type[2];
			} else if (implicit_type !== null) {
				type = implicit_type[1];
			} else {
				return;
			}
			// Verify if the resource is not already handled
			if (resource in handled_resources) {
				return;
			}
			// Mark the resource as handled (but not loaded yet)
			handled_resources[resource] = false;
			// Load resource
			switch (type) {
				case 'js':
					// Create SCRIPT element
					node = document.createElement('script');
					node.src = resource;
					node.type = 'text/javascript';
					head.appendChild(node);
					// Watch loading state
					var version = navigator.appVersion.match(/MSIE (\d)/);
					if (version !== null && parseInt(version[1], 10) < 9) {
						// IE<9
						node.onreadystatechange = function () {
							if (/ded|co/.test(this.readyState)) {
								handled_resources[resource] = true;
							}
						};
					} else {
						// Other browsers
						node.onload = function () {
							handled_resources[resource] = true;
						};
					}
					break;
				case 'css':
					// Create LINK element
					node = document.createElement('link');
					node.rel = 'styleSheet';
					node.href = resource;
					head.appendChild(node);
					// Watch loading state
					watchStylesheet(node, resource);
					break;
				default:
					delete handled_resources[resource];
					return;
			}
		},


		// Watch if all resources have been loaded
		watchResources = function watchResources(callback, resourcesToLoad) {
			for (var resource in handled_resources) {
				if (!handled_resources[resource]) {
					setTimeout(function () {
						watchResources(callback, resourcesToLoad);
					}, 50);
					return;
				}
			}
			if (typeof callback == 'function') {
				callback();
			}
			loadResources(resourcesToLoad);
		},


		// Watch if a CSS resource has been loaded
		watchStylesheet = function watchStylesheet(node, resource) {
			if (node.sheet || node.styleSheet) {
				handled_resources[resource] = true;
			} else {
				setTimeout(function () {
					watchStylesheet(node, resource);
				}, 50);
			}
		};

		// Load resources
		loadResources(arguments);
	}
	return toast;
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/scrollmonitor/scrollMonitor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = factory();
	} else {
		window.scrollMonitor = factory();
	}
})(function () {

	var isOnServer = typeof window === 'undefined';
	var isInBrowser = !isOnServer;

	var scrollTop = function scrollTop() {
		if (isOnServer) {
			return 0;
		}
		return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
	};

	var exports = {};

	var watchers = [];

	var VISIBILITYCHANGE = 'visibilityChange';
	var ENTERVIEWPORT = 'enterViewport';
	var FULLYENTERVIEWPORT = 'fullyEnterViewport';
	var EXITVIEWPORT = 'exitViewport';
	var PARTIALLYEXITVIEWPORT = 'partiallyExitViewport';
	var LOCATIONCHANGE = 'locationChange';
	var STATECHANGE = 'stateChange';

	var eventTypes = [VISIBILITYCHANGE, ENTERVIEWPORT, FULLYENTERVIEWPORT, EXITVIEWPORT, PARTIALLYEXITVIEWPORT, LOCATIONCHANGE, STATECHANGE];

	var defaultOffsets = { top: 0, bottom: 0 };

	var getViewportHeight = function getViewportHeight() {
		if (isOnServer) {
			return 0;
		}
		return window.innerHeight || document.documentElement.clientHeight;
	};

	var getDocumentHeight = function getDocumentHeight() {
		if (isOnServer) {
			return 0;
		}
		// jQuery approach
		// whichever is greatest
		return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight);
	};

	exports.viewportTop = null;
	exports.viewportBottom = null;
	exports.documentHeight = null;
	exports.viewportHeight = getViewportHeight();

	var previousDocumentHeight;
	var latestEvent;

	var calculateViewportI;
	function calculateViewport() {
		exports.viewportTop = scrollTop();
		exports.viewportBottom = exports.viewportTop + exports.viewportHeight;
		exports.documentHeight = getDocumentHeight();
		if (exports.documentHeight !== previousDocumentHeight) {
			calculateViewportI = watchers.length;
			while (calculateViewportI--) {
				watchers[calculateViewportI].recalculateLocation();
			}
			previousDocumentHeight = exports.documentHeight;
		}
	}

	function recalculateWatchLocationsAndTrigger() {
		exports.viewportHeight = getViewportHeight();
		calculateViewport();
		updateAndTriggerWatchers();
	}

	var recalculateAndTriggerTimer;
	function debouncedRecalcuateAndTrigger() {
		clearTimeout(recalculateAndTriggerTimer);
		recalculateAndTriggerTimer = setTimeout(recalculateWatchLocationsAndTrigger, 100);
	}

	var updateAndTriggerWatchersI;
	function updateAndTriggerWatchers() {
		// update all watchers then trigger the events so one can rely on another being up to date.
		updateAndTriggerWatchersI = watchers.length;
		while (updateAndTriggerWatchersI--) {
			watchers[updateAndTriggerWatchersI].update();
		}

		updateAndTriggerWatchersI = watchers.length;
		while (updateAndTriggerWatchersI--) {
			watchers[updateAndTriggerWatchersI].triggerCallbacks();
		}
	}

	function ElementWatcher(watchItem, offsets) {
		var self = this;

		this.watchItem = watchItem;

		if (!offsets) {
			this.offsets = defaultOffsets;
		} else if (offsets === +offsets) {
			this.offsets = { top: offsets, bottom: offsets };
		} else {
			this.offsets = {
				top: offsets.top || defaultOffsets.top,
				bottom: offsets.bottom || defaultOffsets.bottom
			};
		}

		this.callbacks = {}; // {callback: function, isOne: true }

		for (var i = 0, j = eventTypes.length; i < j; i++) {
			self.callbacks[eventTypes[i]] = [];
		}

		this.locked = false;

		var wasInViewport;
		var wasFullyInViewport;
		var wasAboveViewport;
		var wasBelowViewport;

		var listenerToTriggerListI;
		var listener;
		function triggerCallbackArray(listeners) {
			if (listeners.length === 0) {
				return;
			}
			listenerToTriggerListI = listeners.length;
			while (listenerToTriggerListI--) {
				listener = listeners[listenerToTriggerListI];
				listener.callback.call(self, latestEvent);
				if (listener.isOne) {
					listeners.splice(listenerToTriggerListI, 1);
				}
			}
		}
		this.triggerCallbacks = function triggerCallbacks() {

			if (this.isInViewport && !wasInViewport) {
				triggerCallbackArray(this.callbacks[ENTERVIEWPORT]);
			}
			if (this.isFullyInViewport && !wasFullyInViewport) {
				triggerCallbackArray(this.callbacks[FULLYENTERVIEWPORT]);
			}

			if (this.isAboveViewport !== wasAboveViewport && this.isBelowViewport !== wasBelowViewport) {

				triggerCallbackArray(this.callbacks[VISIBILITYCHANGE]);

				// if you skip completely past this element
				if (!wasFullyInViewport && !this.isFullyInViewport) {
					triggerCallbackArray(this.callbacks[FULLYENTERVIEWPORT]);
					triggerCallbackArray(this.callbacks[PARTIALLYEXITVIEWPORT]);
				}
				if (!wasInViewport && !this.isInViewport) {
					triggerCallbackArray(this.callbacks[ENTERVIEWPORT]);
					triggerCallbackArray(this.callbacks[EXITVIEWPORT]);
				}
			}

			if (!this.isFullyInViewport && wasFullyInViewport) {
				triggerCallbackArray(this.callbacks[PARTIALLYEXITVIEWPORT]);
			}
			if (!this.isInViewport && wasInViewport) {
				triggerCallbackArray(this.callbacks[EXITVIEWPORT]);
			}
			if (this.isInViewport !== wasInViewport) {
				triggerCallbackArray(this.callbacks[VISIBILITYCHANGE]);
			}
			switch (true) {
				case wasInViewport !== this.isInViewport:
				case wasFullyInViewport !== this.isFullyInViewport:
				case wasAboveViewport !== this.isAboveViewport:
				case wasBelowViewport !== this.isBelowViewport:
					triggerCallbackArray(this.callbacks[STATECHANGE]);
			}

			wasInViewport = this.isInViewport;
			wasFullyInViewport = this.isFullyInViewport;
			wasAboveViewport = this.isAboveViewport;
			wasBelowViewport = this.isBelowViewport;
		};

		this.recalculateLocation = function () {
			if (this.locked) {
				return;
			}
			var previousTop = this.top;
			var previousBottom = this.bottom;
			if (this.watchItem.nodeName) {
				// a dom element
				var cachedDisplay = this.watchItem.style.display;
				if (cachedDisplay === 'none') {
					this.watchItem.style.display = '';
				}

				var boundingRect = this.watchItem.getBoundingClientRect();
				this.top = boundingRect.top + exports.viewportTop;
				this.bottom = boundingRect.bottom + exports.viewportTop;

				if (cachedDisplay === 'none') {
					this.watchItem.style.display = cachedDisplay;
				}
			} else if (this.watchItem === +this.watchItem) {
				// number
				if (this.watchItem > 0) {
					this.top = this.bottom = this.watchItem;
				} else {
					this.top = this.bottom = exports.documentHeight - this.watchItem;
				}
			} else {
				// an object with a top and bottom property
				this.top = this.watchItem.top;
				this.bottom = this.watchItem.bottom;
			}

			this.top -= this.offsets.top;
			this.bottom += this.offsets.bottom;
			this.height = this.bottom - this.top;

			if ((previousTop !== undefined || previousBottom !== undefined) && (this.top !== previousTop || this.bottom !== previousBottom)) {
				triggerCallbackArray(this.callbacks[LOCATIONCHANGE]);
			}
		};

		this.recalculateLocation();
		this.update();

		wasInViewport = this.isInViewport;
		wasFullyInViewport = this.isFullyInViewport;
		wasAboveViewport = this.isAboveViewport;
		wasBelowViewport = this.isBelowViewport;
	}

	ElementWatcher.prototype = {
		on: function on(event, callback, isOne) {

			// trigger the event if it applies to the element right now.
			switch (true) {
				case event === VISIBILITYCHANGE && !this.isInViewport && this.isAboveViewport:
				case event === ENTERVIEWPORT && this.isInViewport:
				case event === FULLYENTERVIEWPORT && this.isFullyInViewport:
				case event === EXITVIEWPORT && this.isAboveViewport && !this.isInViewport:
				case event === PARTIALLYEXITVIEWPORT && this.isAboveViewport:
					callback.call(this, latestEvent);
					if (isOne) {
						return;
					}
			}

			if (this.callbacks[event]) {
				this.callbacks[event].push({ callback: callback, isOne: isOne || false });
			} else {
				throw new Error('Tried to add a scroll monitor listener of type ' + event + '. Your options are: ' + eventTypes.join(', '));
			}
		},
		off: function off(event, callback) {
			if (this.callbacks[event]) {
				for (var i = 0, item; item = this.callbacks[event][i]; i++) {
					if (item.callback === callback) {
						this.callbacks[event].splice(i, 1);
						break;
					}
				}
			} else {
				throw new Error('Tried to remove a scroll monitor listener of type ' + event + '. Your options are: ' + eventTypes.join(', '));
			}
		},
		one: function one(event, callback) {
			this.on(event, callback, true);
		},
		recalculateSize: function recalculateSize() {
			this.height = this.watchItem.offsetHeight + this.offsets.top + this.offsets.bottom;
			this.bottom = this.top + this.height;
		},
		update: function update() {
			this.isAboveViewport = this.top < exports.viewportTop;
			this.isBelowViewport = this.bottom > exports.viewportBottom;

			this.isInViewport = this.top <= exports.viewportBottom && this.bottom >= exports.viewportTop;
			this.isFullyInViewport = this.top >= exports.viewportTop && this.bottom <= exports.viewportBottom || this.isAboveViewport && this.isBelowViewport;
		},
		destroy: function destroy() {
			var index = watchers.indexOf(this),
			    self = this;
			watchers.splice(index, 1);
			for (var i = 0, j = eventTypes.length; i < j; i++) {
				self.callbacks[eventTypes[i]].length = 0;
			}
		},
		// prevent recalculating the element location
		lock: function lock() {
			this.locked = true;
		},
		unlock: function unlock() {
			this.locked = false;
		}
	};

	var eventHandlerFactory = function eventHandlerFactory(type) {
		return function (callback, isOne) {
			this.on.call(this, type, callback, isOne);
		};
	};

	for (var i = 0, j = eventTypes.length; i < j; i++) {
		var type = eventTypes[i];
		ElementWatcher.prototype[type] = eventHandlerFactory(type);
	}

	if (isInBrowser) {
		try {
			calculateViewport();
		} catch (e) {
			try {
				window.$(calculateViewport);
			} catch (e) {
				throw new Error('If you must put scrollMonitor in the <head>, you must use jQuery.');
			}
		}
	}

	function scrollMonitorListener(event) {
		latestEvent = event;
		calculateViewport();
		updateAndTriggerWatchers();
	}

	if (isInBrowser) {
		if (window.addEventListener) {
			window.addEventListener('scroll', scrollMonitorListener);
			window.addEventListener('resize', debouncedRecalcuateAndTrigger);
		} else {
			// Old IE support
			window.attachEvent('onscroll', scrollMonitorListener);
			window.attachEvent('onresize', debouncedRecalcuateAndTrigger);
		}
	}

	exports.beget = exports.create = function (element, offsets) {
		if (typeof element === 'string') {
			element = document.querySelector(element);
		} else if (element && element.length > 0) {
			element = element[0];
		}

		var watcher = new ElementWatcher(element, offsets);
		watchers.push(watcher);
		watcher.update();
		return watcher;
	};

	exports.update = function () {
		latestEvent = null;
		calculateViewport();
		updateAndTriggerWatchers();
	};
	exports.recalculateLocations = function () {
		exports.documentHeight = 0;
		exports.update();
	};

	return exports;
});

/***/ }),

/***/ "/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!/tool/node_modules/css-loader/index.js??ref--9-1!/tool/node_modules/postcss-loader/lib/index.js??ref--9-2!/tool/node_modules/sass-loader/lib/loader.js??ref--9-3!/tool/project/client/src/site__cu/modules/cu-product-compare/cu-product-compare.module.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "multi /tool/project/client/src/core/modules/cu-product-compare/cu-product-compare.module.js /tool/project/client/src/site__cu/modules/cu-product-compare/cu-product-compare.module.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cu-product-compare/cu-product-compare.module.js");
module.exports = __webpack_require__("/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!/tool/node_modules/css-loader/index.js??ref--9-1!/tool/node_modules/postcss-loader/lib/index.js??ref--9-2!/tool/node_modules/sass-loader/lib/loader.js??ref--9-3!/tool/project/client/src/site__cu/modules/cu-product-compare/cu-product-compare.module.scss");


/***/ })

},["multi /tool/project/client/src/core/modules/cu-product-compare/cu-product-compare.module.js /tool/project/client/src/site__cu/modules/cu-product-compare/cu-product-compare.module.scss"]);


// WEBPACK FOOTER //
// scripts/cu-product-compare.module--ebfb11fffc7e09d14ffe.js